'use strict';

// Constructor
var Comments = function() {

  var self = this;

  self.config = {
    'singleComment'         :  '.comments__single-comment',
    'replyButton'           :  '.comments__reply-button',
    'replyFormContainer'    :  '.comments__reply-form-container',
    'hideReplyFormButton'   :  '.comments__hide-reply-form',
    'defaultFormContainer'  :  '.comments__form-section',
    'form'                  :  '.comments__form',
    'parentIdInput'         :  '#comment_parent',
    'scrollToFormButton'    :  '.comments__scroll-to-form'
  }

  var $replyButton = $(self.config.replyButton);
  var $defaultFormContainer = $(self.config.defaultFormContainer);
  var $form = $(self.config.form);
  var $parentIdInput = $(self.config.parentIdInput);
  var $replyFormContainer = $(self.config.replyFormContainer);
  var $scrollToFormButton = $(self.config.scrollToFormButton);

  self.clickHandler = function($button, cb) {
    $button.on('click.comments', function() {
      if (typeof cb === 'function') {
        cb();
      }
    });
  }

  self.parseComments = function() {
    $(self.config.singleComment).each(function() {
      var $this = $(this);
      var _$replyButton = $this.find($replyButton);
      var _$replyFormContainer = $this.find(self.config.replyFormContainer);
      var _$hideReplyFormButton = $this.find(self.config.hideReplyFormButton);
      var _commentIndex = $this.attr('id').match(/\d+/)[0];
      var moveFormCb = function() {
        self.moveForm(_$replyButton, _$replyFormContainer, _commentIndex);
      };
      var removeFormCb = function() {
        self.removeReplyForm(_$replyButton, _$replyFormContainer);
      };

      self.clickHandler(_$replyButton, moveFormCb);
      self.clickHandler(_$hideReplyFormButton, removeFormCb);
    });
  }

  self.moveForm = function(_$button, _$container, _commentIndex) {
    self.hideContainer($replyFormContainer.not(_$container));
    $scrollToFormButton.addClass('is-disabled');
    $replyButton.removeClass('is-disabled');
    _$button.addClass('is-disabled');
    $form.appendTo(_$container);
    self.setInputParentIndex(_commentIndex);
    self.showContainer(_$container);
    self.hideContainer($defaultFormContainer);
  }

  self.removeReplyForm = function(_$button, _$container) {
    var hideCb = function() {
      $form.appendTo($defaultFormContainer);
      self.showContainer($defaultFormContainer);
    };

    $scrollToFormButton.removeClass('is-disabled');
    _$button.removeClass('is-disabled');
    self.hideContainer(_$container, hideCb);
  }

  self.showContainer = function(_$container) {
    _$container
      .velocity(
        'slideDown',{
          duration: 400,
          easing: 'easeOutQuart'
        })
      .velocity({
        opacity: 1
      });
  }

  self.hideContainer = function(_$container, cb) {
    _$container
      .velocity({
        opacity: 0
      })
      .velocity(
        'slideUp',{
          duration: 400,
          easing: 'easeOutQuart',
          complete: function() {
            if (typeof cb === 'function') {
              cb();
            }
          }
        });
  }

  self.setInputParentIndex = function(index) {
    $parentIdInput.attr('value', index);
  }

  self.init = function() {
    self.parseComments();
  }
};

module.exports = Comments;
